import Menu from './Menu.js';
import {CreateWidget} from './CreateWidget.js';

import  { useState } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect 
} from "react-router-dom";
import {Pages} from './Pages.js';

import {Balance} from './Balance.js';
import Cookies from 'universal-cookie';
import RedPage  from './RedPage'; 
import RedWidget  from './RedWidget';
import { Widgets } from './Widgets';
import WidgetImplementationFromRoute from './WidgetImplementationFromRoute';
import {VkGroupCallback} from './VkGroupCallback';
import {VkCodeCallback} from './VkCodeCallback';
import {VkCreateWidget} from './VkCreateWidget';
import VkWidgetImplementationFromRoute from './VkWidgetImplementationFromRoute';
import {HeaderInfo} from './HeaderInfo';
import {SenderPage} from './SenderPage';
import {MailingPage} from './MailingPage';
import MailingStats from './MailingStats';
import {Auth} from './Auth.js';
import {VkLogin} from './VkLogin.js';
import {Reg} from './Reg.js';
import {RestorePass} from './RestorePass.js'

import {EmailConfirmation} from './EmailConfirmation.js'
import {PassCreator} from './PassCreator.js'
import { LkWrapper } from './LkWrapper.js';

export function App() {

  
  
  const [showSuccessMsg, setShowSucessMsg] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  
  const [errorMsg, setErrorMsg] = useState('error 404');
  const [successMsg, setSuccessMsg] = useState('');
  const [showCreateDropdown, setShowCreateDropdown] = useState(false)
  const [showCreatedDropdown, setShowCreatedDropdown] = useState(false)

  var msgTimer = 2000

  

  const doShowSuccessMsg = (msg) => {
    setSuccessMsg(msg)
    setShowSucessMsg(true)
    setTimeout(() => { 
      setShowSucessMsg(false)
    }, msgTimer)
  }

  const doShowErrorMsg = (msg) => {
    setErrorMsg(msg)
    setShowErrorMsg(true)
    setTimeout(() => { 
      setShowErrorMsg(false)
    }, msgTimer)
  }
  
  const cookies = new Cookies();
  //console.log(window.document.cookie)
    //if ( (cookies.get('tgsubs_token') == undefined)) {
       
      //  window.location = '/auth'
    //}
  
    return (
      
      
  
              
              <Router>
                <Switch>
                  
                <Route exact path="/" render={(props) => <Auth />}/>
                  <Route exact path='/vklogin' render={(props) => <VkLogin />}/>
                  <Route exact path="/auth/" render={(props) => <Auth />}/>
                  <Route exact path="/reg/" component={ Reg } />
                  <Route exact path="/emailconfirmation/:token/" component={EmailConfirmation  } />
                  <Route exact path="/restorePassword/" component={ RestorePass } />
                  <Route exact path="/createnewpass/:token/" component={ PassCreator } />
                  <Route exact path="/createwidget" render={(props) =><LkWrapper><CreateWidget doShowSuccessMsg={doShowSuccessMsg} doShowErrorMsg={doShowErrorMsg} /></LkWrapper> }/>
                  <Route exact path="/widgets" render={(props) => <LkWrapper><Widgets /></LkWrapper >}/>
                  <Route exact path="/pages" render={(props) => <LkWrapper><Pages/></LkWrapper>}/>
                  <Route exact path="/balance" render={(props) => <LkWrapper><Balance /></LkWrapper>}/>
                  <Route exact path="/redpage/:page_alias" render={(props) =><LkWrapper><RedPage /> </LkWrapper>}/>
                  
                  <Route exact path="/widgetimplementation/:alias" render={(props) => <LkWrapper><WidgetImplementationFromRoute /></LkWrapper>}/>
                  <Route exact path="/vkwidgetimplementation/:alias" render={(props) => <LkWrapper><VkWidgetImplementationFromRoute /></LkWrapper>}/>
                  <Route exact path="/redwidget/:social/:alias" render={(props) => <LkWrapper><RedWidget /></LkWrapper>}/>
                  
                  <Route exact path="/callback/" render={(props) => <LkWrapper><VkCodeCallback /></LkWrapper>}/>
                  <Route exact path="/groupcallback/" render={(props) => <LkWrapper><VkGroupCallback /></LkWrapper>}/>

                  <Route exact path="/vkcreatewidget/" render={(props) => <LkWrapper><VkCreateWidget /></LkWrapper>}/>
                  <Route exact path="/sender" render={(props) => <LkWrapper><SenderPage /></LkWrapper>}/>
                  <Route exact path="/mailing" render={(props) => <LkWrapper><MailingPage /></LkWrapper>}/>
                  <Route exact path="/mailingstats/:mailing_id" render={(props) => <LkWrapper><MailingStats /></LkWrapper>}/>
                </Switch>
            </Router>
           
    );
  
  
}

